import axios from "axios";
// 角色职能api
import request from "@/util/request";
const CancelToken = axios.CancelToken;
let cancel;
export function cancelRequest() {
	if (typeof cancel === "function") {
		// 取消请求
		cancel();
	}
}

// 获取职能列表
export function getFunctionalList(data) {
	return request({
		url: `/auth-s/auth/roles`, // 避免拦截
		method: "post",
		data,
	});
}

// 获取角色列表
export function getRoleList(data) {
	return request({
		url: `/auth-s/auth/roles`,
		method: "post",
		data,
	});
}
// 添加角色
export function addRole(data) {
	return request({
		url: `/auth-s/auth/role`,
		method: "post",
		data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 克隆角色
export function cloneRole(data) {
	return request({
		url: `/auth-s/auth/role/clone`,
		method: "post",
		data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 删除角色
export function deleteRole(id) {
	return request({
		url: `/auth-s/auth/role/${id}`,
		method: "delete",
	});
}
// 更新角色
export function updateRole(id, data) {
	return request({
		url: `/auth-s/auth/role/${id}`,
		method: "post",
		data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}

// 查询角色详情
export function getRoleDetail(id) {
	//已弃用，请使用login中的getRoles
	return request({
		url: `/auth-s/auth/role/${id}`,
		method: "get",
	});
}

// 查询公司下职能功能码结构(LIST结构)
export function getStruct() {
	return request({
		url: `/auth-s/auth/function/struct `,
		method: "get",
	});
}
// 查询waibu公司下职能功能码结构(LIST结构)
export function getOStruct() {
	return request({
		url: `/auth-s/auth/out/function/struct `,
		method: "get",
	});
}

// 获取职能列表
export function getOFunctionalList(data) {
	return request({
		url: `/auth-s/auth/out/roles`, // 避免拦截
		method: "post",
		data,
	});
}

// 获取角色列表
export function getORoleList(data) {
	return request({
		url: `/auth-s/auth/out/roles`,
		method: "post",
		data,
	});
}
// 添加角色
export function addORole(data) {
	return request({
		url: `/auth-s/auth/out/role`,
		method: "post",
		data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 克隆角色
export function cloneORole(data) {
	return request({
		url: `/auth-s/auth/out/role/clone`,
		method: "post",
		data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 删除角色
export function deleteORole(id) {
	return request({
		url: `/auth-s/auth/out/role/${id}`,
		method: "delete",
	});
}
// 更新角色
export function updateORole(id, data) {
	return request({
		url: `/auth-s/auth/out/role/${id}`,
		method: "post",
		data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}

//创建外部角色
export function getOutRoles(data) {
	return request({
		url: `/auth-s/auth/out/roles`,
		method: "post",
		data,
	});
}
// 查询角色详情
export function getRoleODetail(id) {
	return request({
		url: `/auth-s/auth/out/role/${id}`,
		method: "get",
	});
}



// WEBPACK FOOTER //
// ./src/api/manage/roleFunc.js